export const MESES = [ 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro' ];

export const DIAS_COMPLETOS = [ 'Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira',
  'Quinta-Feira', 'Sexta-Feira', 'Sábado' ];

export const DIAS_INICIAL = [ 'D', 'S', 'T', 'Q', 'Q', 'S', 'S' ];

export function arrayBufferToString(buffer) {
  let binary = '';
  let bytes = new Uint8Array(buffer);
  let len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[ i ]);
  }
  return binary;
}

export function cpf(value: string) {
  if (!value) { return value; }
  return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export function cnpj(value: string) {
  if (!value) { return value; }
  return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export function cns(value: string) {
  if (!value) { return value; }
  return value.replace(/(\d{3})(\d{4})(\d{4})(\d{4})/, "$1.$2.$3.$4");
}

export function cep(value: string) {
  if (!value) { return value; }
  return value.replace(/(\d{2})(\d{3})(\d{3})/, "$1.$2-$3");
}

export function telefone(value: string) {
  if (!value) { return value; }

  const soDigitos = value.replace(/\D/g, '');

  if (soDigitos.length === 10) {
    return value.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }
  if (soDigitos.length === 11) {
    return value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }

  return value;
}



// WEBPACK FOOTER //
// ./src/app/util/format.ts